import { createActorContext } from "@xstate/react";
import { uploadMachine } from "../state/uploadMachine";

const UploadMachineContext = createActorContext(uploadMachine);

export const UploadMachineProvider = UploadMachineContext.Provider;
export const useUploadMachine = UploadMachineContext.useActorRef;
export const useUploadMachineSelector = UploadMachineContext.useSelector;
